export default "__VITE_ASSET__DA1w7FdF__"